import { z } from 'zod';
import { AnalysisOutputSchema } from './analysis-output.js';
/**
 * Schemas para análises persistidas (Fase 7).
 *
 * Persistência é opt-in: o user clica "Salvar análise" no fim do diagnóstico.
 * Sem isso, a análise vive só na sessão do browser.
 */
export const SaveAnalysisRequestSchema = z.object({
    output: AnalysisOutputSchema,
    pdfBytes: z.number().int().nullable().optional(),
    pdfPages: z.number().int().nullable().optional(),
    label: z.string().max(120).optional(),
});
export const SavedAnalysisListItemSchema = z.object({
    id: z.string().uuid(),
    createdAt: z.string(),
    provider: z.string(),
    modelId: z.string(),
    findingsCount: z.number().int(),
    criticalCount: z.number().int(),
    durationMs: z.number().int(),
    pdfBytes: z.number().int().nullable(),
    pdfPages: z.number().int().nullable(),
    label: z.string().nullable(),
    archivedAt: z.string().nullable(),
    positioningSentence: z.string().nullable(),
});
export const SavedAnalysisDetailSchema = z.object({
    id: z.string().uuid(),
    createdAt: z.string(),
    provider: z.string(),
    modelId: z.string(),
    promptVersion: z.string(),
    findingsCount: z.number().int(),
    criticalCount: z.number().int(),
    durationMs: z.number().int(),
    pdfBytes: z.number().int().nullable(),
    pdfPages: z.number().int().nullable(),
    label: z.string().nullable(),
    archivedAt: z.string().nullable(),
    output: AnalysisOutputSchema,
});
//# sourceMappingURL=saved-analysis.js.map